import { RECURSO_CATEGORIA, RECURSO_CLASE, RECURSO_SECTOR_ESTADO_TIPO } from "./constants";
import DateService from "./DateService";
import { removeTildes } from "./FunctionHelper";
var CategoriaRecursoFiltro;
(function (CategoriaRecursoFiltro) {
    CategoriaRecursoFiltro["PERSONAL"] = "Personal";
    CategoriaRecursoFiltro["BRIGADA"] = "Brigada";
    CategoriaRecursoFiltro["Terrestre"] = "Terrestre";
    CategoriaRecursoFiltro["AEREO"] = "Aereo";
    CategoriaRecursoFiltro["OTRO"] = "Otros";
})(CategoriaRecursoFiltro || (CategoriaRecursoFiltro = {}));
export function getCategoriaRecursoPorClase(tipo) {
    const claseId = tipo.RECURSO_CATEGORIA.RECURSO_CLASE.ID_RECURSO_CLASE;
    const categoriaId = tipo.RECURSO_CATEGORIA.ID_RECURSO_CATEGORIA;
    if (claseId === RECURSO_CLASE.PERSONAL ||
        claseId === RECURSO_CLASE.MEDIO_PERSONAL)
        return CategoriaRecursoFiltro.PERSONAL;
    if (claseId === RECURSO_CLASE.BRIGADA)
        return CategoriaRecursoFiltro.BRIGADA;
    if (claseId === RECURSO_CLASE.MEDIO_CONTRA_INCENDIO &&
        categoriaId === RECURSO_CATEGORIA.CAMION)
        return CategoriaRecursoFiltro.Terrestre;
    if (claseId === RECURSO_CLASE.MEDIO_AEREO ||
        claseId === RECURSO_CLASE.HERMES)
        return CategoriaRecursoFiltro.AEREO;
    if (claseId === RECURSO_CLASE.MEDIO_CONTRA_INCENDIO &&
        categoriaId !== RECURSO_CATEGORIA.CAMION)
        return CategoriaRecursoFiltro.OTRO;
    return null;
}
// TODO: BORRAR PARA HACER EL COLOR DINÁMICO MEDIANTE LA VARIABLE DE LA TABLA EN BD
export function getRowColor(recursoSectorEstado) {
    if (!recursoSectorEstado || recursoSectorEstado.length === 0)
        return null;
    const estadoMasReciente = recursoSectorEstado.reduce((ultimo, actual) => {
        return (actual.RECURSO_SECTOR_ESTADO_TIPO?.ORDEN ?? -Infinity) > (ultimo.RECURSO_SECTOR_ESTADO_TIPO?.ORDEN ?? -Infinity) ? actual : ultimo;
    }, recursoSectorEstado?.[0]);
    const estadoRecurso = estadoMasReciente?.RECURSO_SECTOR_ESTADO_TIPO?.NOMBRE;
    return estadoRecurso ? `recurso_${removeTildes(estadoRecurso).replaceAll(' ', '_').toUpperCase()}` : null;
}
export const getFechaDespacho = (recursoSectorEstado) => {
    if (!recursoSectorEstado.length)
        return null;
    const estadoInicio = recursoSectorEstado.find(estado => estado.RECURSO_SECTOR_ESTADO_TIPO?.NOMBRE === RECURSO_SECTOR_ESTADO_TIPO.ASIGNADO.NOMBRE);
    return estadoInicio?.FECHA || null;
};
export const getLastEstadoRecurso = (recursoSectorEstados) => {
    if (!recursoSectorEstados.length)
        return null;
    return recursoSectorEstados.reduce((max, estado) => DateService.toDayjs(estado.FECHA) > DateService.toDayjs(max.FECHA) ? estado : max);
};
export const isRecursoActivo = (recursoSectorEstados) => {
    if (!recursoSectorEstados || recursoSectorEstados.length === 0)
        return false;
    return !recursoSectorEstados.some(estado => estado.RECURSO_SECTOR_ESTADO_TIPO?.NOMBRE === 'Desasignado');
};
export const isPrestamo = (item) => {
    const indicativo = item.INDICATIVO;
    const issi = item.GEO_RECURSO_DISPOSITIVO?.GEO_DISPOSITIVO?.CODIGO_EXTERNO;
    return Boolean(indicativo && issi && indicativo !== issi);
};
export const getRecursosAereos = (recursosEnIncendio) => {
    const recursosAereosRaw = recursosEnIncendio.filter(r => r.RECURSO.RECURSO_TIPO.RECURSO_CATEGORIA.RECURSO_CLASE.NOMBRE === 'MEDIO AEREO' ||
        r.RECURSO.RECURSO_TIPO.RECURSO_CATEGORIA.RECURSO_CLASE.NOMBRE === 'HERMES');
    return recursosAereosRaw;
};
export const getBrigadas = (recursosEnIncendio) => {
    const recursosBrigada = recursosEnIncendio.filter(r => r.RECURSO.RECURSO_TIPO.RECURSO_CATEGORIA.RECURSO_CLASE.NOMBRE === 'BRIGADA');
    return recursosBrigada;
};
export const getRecursosGuardias = (recursosEnIncendio) => {
    const recursosGuardias = recursosEnIncendio.filter(r => r.RECURSO.RECURSO_TIPO.RECURSO_CATEGORIA.RECURSO_CLASE.NOMBRE === 'PERSONAL' ||
        r.RECURSO.RECURSO_TIPO.RECURSO_CATEGORIA.RECURSO_CLASE.NOMBRE.toUpperCase().includes('MEDIO PERSONAL'.toUpperCase()));
    return recursosGuardias;
};
export const getOtrosRecursos = (recursosEnIncendio) => {
    return recursosEnIncendio.filter(r => {
        const nombreClase = r.RECURSO.RECURSO_TIPO.RECURSO_CATEGORIA.RECURSO_CLASE.NOMBRE.toUpperCase();
        return (nombreClase !== 'MEDIO AEREO' &&
            nombreClase !== 'HERMES' &&
            nombreClase !== 'BRIGADA' &&
            nombreClase !== 'PERSONAL' &&
            !nombreClase.includes('MEDIO PERSONAL'));
    });
};
export const getNombreGuardia = (recursoSector) => {
    if (!recursoSector?.MEDIO_PERSONAL || recursoSector?.RECURSO?.RECURSO_TIPO?.NUMERO_COMPONENTES)
        return '';
    return `${recursoSector.MEDIO_PERSONAL.PERSONAL?.APELLIDOS || ''}, ${recursoSector.MEDIO_PERSONAL.PERSONAL?.NOMBRE || ''}`;
};
export const getColorRecursoSectorActual = (recursoSectorEstado, defaultColor = 'white') => {
    const estadoMasReciente = getLastEstadoRecurso(recursoSectorEstado);
    return estadoMasReciente?.RECURSO_SECTOR_ESTADO_TIPO?.COLOR || defaultColor;
};
export const getNombreRecurso = (recurso) => {
    if (recurso.ALIAS)
        return recurso.ALIAS;
    if (recurso.MEDIO?.MEDIO)
        return recurso.MEDIO.MEDIO;
    const nombre = [recurso.PERSONAL?.NOMBRE, recurso.PERSONAL?.APELLIDOS].filter(Boolean).join(' ');
    if (nombre)
        return nombre;
    return recurso.IDENTIFICADOR || recurso.ID_RECURSO;
};
export const resolveGestionInterna = (recurso, index) => {
    const idTipo = recurso?.ID_RECURSO_TIPO;
    const desdeCatalogo = idTipo ? index[idTipo.toLowerCase()] : undefined;
    return desdeCatalogo ?? recurso?.RECURSO_TIPO?.GESTION_INTERNA ?? true;
};
export const resolveGestionInternaDeTipo = (tipo, index) => {
    const idTipo = tipo?.ID_RECURSO_TIPO;
    const desdeCatalogo = idTipo ? index[idTipo.toLowerCase()] : undefined;
    return desdeCatalogo ?? tipo?.GESTION_INTERNA ?? true;
};
